export enum DiscountTypes {
  NO_DISCOUNT = 'Ingen rabatt',
  DISCOUNT_ONE = 'Rabatt 1',
  DISCOUNT_TWO = 'Rabatt 2',
  DISCOUNT_THREE = 'Rabatt 3'
}
